import { render } from "./reportHistoryFeed.vue?vue&type=template&id=4a3ca3c6"
import script from "./reportHistoryFeed.vue?vue&type=script&lang=js"
export * from "./reportHistoryFeed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__